import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
import authReducer from '../features/auth/authSlice'
//import { skugroupApi } from '../features/products/skugroupSlice';
import { actionsApi } from '../features/actions/actionsSlice';
import { productApi } from '../features/products/productSlice';
import { metadataApi } from '../features/products/metadataSlice';
import { skuImageApi } from '../features/products/skuImageSlice';
import { assigneeApi } from '../features/assigneeSlice';
// Redux Slicer generated paths
// RSGP
import { productfamilyApi } from '../features/model/productfamilySlice';
import { templateApi } from '../features/model/templateSlice';
import { skuApi } from '../features/model/skuSlice';
import { skugroupApi } from '../features/model/skugroupSlice';
import { skuimageApi } from '../features/model/skuimageSlice';
import { storeApi } from '../features/model/storeSlice';
import { storeskuApi } from '../features/model/storeskuSlice';
import { skumetadataApi } from '../features/model/skumetadataSlice';
import { orderApi } from '../features/model/orderSlice';
import { trackinginfoApi } from '../features/model/trackinginfoSlice';
import { shippinglabelApi } from '../features/model/shippinglabelSlice';
import { shippinglabelcontentsApi } from '../features/model/shippinglabelcontentsSlice';
import { platetypeApi } from '../features/model/platetypeSlice';
import { plateApi } from '../features/model/plateSlice';
import { lineitemApi } from '../features/model/lineitemSlice';
import { layoutApi } from '../features/model/layoutSlice';
import { itemonplateApi } from '../features/model/itemonplateSlice';
import { remakeApi } from '../features/model/remakeSlice';
import { actionApi } from '../features/model/actionSlice';
import { noteApi } from '../features/model/noteSlice';
import { personApi } from '../features/model/personSlice';
import { permissionApi } from '../features/model/permissionSlice';
import { personpermissionApi } from '../features/model/personpermissionSlice';
import { timeentryApi } from '../features/model/timeentrySlice';
import { reviewApi } from '../features/model/reviewSlice';
import { preferenceApi } from '../features/model/preferenceSlice';
import { designcategoryApi } from '../features/model/designcategorySlice';
import { designApi } from '../features/model/designSlice';
import { designinlayoutApi } from '../features/model/designinlayoutSlice';
import { comboinlayoutApi } from '../features/model/comboinlayoutSlice';
import { fontApi } from '../features/model/fontSlice';
import { fontreferenceApi } from '../features/model/fontreferenceSlice';
import { salesrepApi } from '../features/model/salesrepSlice';
import { discountApi } from '../features/model/discountSlice';
import { contractApi } from '../features/model/contractSlice';
import { refundApi } from '../features/model/refundSlice';
import { bonusApi } from '../features/model/bonusSlice';
import { recurringbonusApi } from '../features/model/recurringbonusSlice';
import { toolprofileApi } from '../features/model/toolprofileSlice';
import { photoApi } from '../features/model/photoSlice';
import { reportsApi } from '../features/reports/reportsSlice';
// END_RSGP

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [skugroupApi.reducerPath]: skugroupApi.reducer,
    [skuImageApi.reducerPath]: skuImageApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [metadataApi.reducerPath]: metadataApi.reducer,
    [actionsApi.reducerPath]: actionsApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
// Redux Slicer generated reductions
// RSGR
    [productfamilyApi.reducerPath]: productfamilyApi.reducer,
    [templateApi.reducerPath]: templateApi.reducer,
    [skuApi.reducerPath]: skuApi.reducer,
    [skugroupApi.reducerPath]: skugroupApi.reducer,
    [skuimageApi.reducerPath]: skuimageApi.reducer,
    [storeApi.reducerPath]: storeApi.reducer,
    [storeskuApi.reducerPath]: storeskuApi.reducer,
    [skumetadataApi.reducerPath]: skumetadataApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [trackinginfoApi.reducerPath]: trackinginfoApi.reducer,
    [shippinglabelApi.reducerPath]: shippinglabelApi.reducer,
    [shippinglabelcontentsApi.reducerPath]: shippinglabelcontentsApi.reducer,
    [platetypeApi.reducerPath]: platetypeApi.reducer,
    [plateApi.reducerPath]: plateApi.reducer,
    [lineitemApi.reducerPath]: lineitemApi.reducer,
    [layoutApi.reducerPath]: layoutApi.reducer,
    [itemonplateApi.reducerPath]: itemonplateApi.reducer,
    [remakeApi.reducerPath]: remakeApi.reducer,
    [actionApi.reducerPath]: actionApi.reducer,
    [noteApi.reducerPath]: noteApi.reducer,
    [personApi.reducerPath]: personApi.reducer,
    [permissionApi.reducerPath]: permissionApi.reducer,
    [personpermissionApi.reducerPath]: personpermissionApi.reducer,
    [timeentryApi.reducerPath]: timeentryApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
    [preferenceApi.reducerPath]: preferenceApi.reducer,
    [designcategoryApi.reducerPath]: designcategoryApi.reducer,
    [designApi.reducerPath]: designApi.reducer,
    [designinlayoutApi.reducerPath]: designinlayoutApi.reducer,
    [comboinlayoutApi.reducerPath]: comboinlayoutApi.reducer,
    [fontApi.reducerPath]: fontApi.reducer,
    [fontreferenceApi.reducerPath]: fontreferenceApi.reducer,
    [salesrepApi.reducerPath]: salesrepApi.reducer,
    [discountApi.reducerPath]: discountApi.reducer,
    [contractApi.reducerPath]: contractApi.reducer,
    [refundApi.reducerPath]: refundApi.reducer,
    [bonusApi.reducerPath]: bonusApi.reducer,
    [recurringbonusApi.reducerPath]: recurringbonusApi.reducer,
    [toolprofileApi.reducerPath]: toolprofileApi.reducer,
    [photoApi.reducerPath]: photoApi.reducer,
// END_RSGR
    auth: authReducer,
    [assigneeApi.reducerPath]: assigneeApi.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
  baseUrl: process.env.REACT_APP_API_URL
});
